<template>
    <div class="fill-height" v-bind="$attrs" style="width: 100%">
        <v-overlay v-if="overlay" :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="!overlay && isLoading" class="d-flex pt-10 align-center justify-center" style="width: 100%">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </div>

        <div v-show="!isLoading" class="fill-height" style="width: 100%">
            <iframe ref="videoFrame" @load="onLoad" style="width: inherit; height: inherit" :src="getVideoUrl" allowfullscreen modestbranding="1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: String,

        overlay: {
            type: Boolean,
            default: false,
        },

        autoPlay: {
            type: Boolean,
            default: false,
        },

        listenForClicks: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isLoading: true,
            clickListener: null,
        };
    },

    mounted() {
        if (this.listenForClicks) {
            this.clickListener = window.addEventListener('blur', this.onClick);
        }
    },
    beforeDestroy() {
        if (this.clickListener) {
            window.removeEventListener('blur', this.clickListener);
        }
    },

    computed: {
        getVideoUrl() {
            return this.url + '?autoplay=' + this.autoPlay + '&mute=1';
        },
    },

    methods: {
        onLoad() {
            this.isLoading = false;
        },

        onClick() {
            if (document.activeElement !== this.$refs.videoFrame) {
                return;
            }

            this.$emit('click', this.activeElement);
        },
    },
};
</script>
